//排除掉T里key不为K的类型,举例 Omit<React.AnchorHTMLAttributes<any>, 'type' | 'onClick'>;除掉type和onclick
// https://stackoverflow.com/questions/46176165/ways-to-get-string-literal-type-of-array-values-without-enum-overhead
export const tuple = (...args) => args;
export const tupleNum = (...args) => args;
